export default "__VITE_ASSET__B130sb0E__"